import React from 'react';
import { Button, Icon } from '@codeparva/ui-components-library';
import { Row } from '../row/Row';
import { CTAButtonTypes } from './CTAButtonTypes';
import { FontAwesomeIcon } from '../../utilities/iconLoader/FontAwesomeIcon';
import { Link } from 'gatsby';
import { mobilescreensize } from '../../utilities/constants';
import { useWindowDimensions } from '../../utilities/Dimensions';

export const CallToActionButton = (
  callToAction: CTAButtonTypes.TCallToAction
) => {
  const { width } = useWindowDimensions();
  return (
    <Row className="flex-1 ctaButtonContainerRow">
      <div
        className={`ctaButtonContainer is-flex ${
          width <= mobilescreensize
            ? 'is-justify-content-center'
            : 'is-justify-content-left'
        }`}
      >
        <CTAButton {...callToAction} />
      </div>
    </Row>
  );
};

export const CTAButton = (callToAction: CTAButtonTypes.TCallToAction) => {
  const { icon, link, label, theme = 'light', type = 'primary' } = callToAction;
  const getIconColor = () => {
    if (type === 'outline') {
      switch (theme) {
        case 'light':
          return 'primary';
        case 'dark':
          return 'white';
        default:
          return 'highlighted';
      }
    } else {
      return 'white';
    }
  };

  const iconColor = getIconColor();
  const getIconForCTAButton = () => {
    if (icon) {
      const { position, type, size = 12 } = icon;
      const GenericIcon = ({ iconName }: CTAButtonTypes.TGenericIconType) => (
        <FontAwesomeIcon
          iconClassName={iconName}
          style={{
            fontSize: size,
          }}
        />
      );
      switch (type) {
        case 'arrow-left':
          return <GenericIcon iconName="FaArrowLeft" />;
        case 'arrow-right':
          return <GenericIcon iconName="FaArrowRight" />;
        case 'call':
          return <GenericIcon iconName="FaPhoneAlt" />;
        case 'reserve':
          return <GenericIcon iconName="FaArchway" />;
        case 'move-in':
          return <GenericIcon iconName="FaPhoneAlt" />;
        default:
          return position === 'right' ? (
            <GenericIcon iconName="FaArrowRight" />
          ) : (
            <GenericIcon iconName="FaArrowLeft" />
          );
      }
    }
    return <></>;
  };

  const CTAButtonOnly = () => (
    <Link
      to={link}
      state={{
        from: label?.toLowerCase().replace(/\s/g, ''),
        dataFrom: 'ctaButton',
      }}
    >
      <Button className={`cp-${type}-button-${theme}`}>{label}</Button>
    </Link>
  );

  const CTAButtonLeftIcon = () => (
    <Link
      to={link}
      state={{
        from: label?.toLowerCase().replace(/\s/g, ''),
        dataFrom: 'ctaButton',
      }}
    >
      <Button className={`cp-${type}-button-${theme}`}>
        <Icon color={iconColor}>{getIconForCTAButton()}</Icon>
        {label}
      </Button>
    </Link>
  );

  const CTAButtonRightIcon = () => (
    <Link
      to={link}
      state={{
        from: label?.toLowerCase().replace(/\s/g, ''),
        dataFrom: 'ctaButton',
      }}
    >
      <Button className={`cp-${type}-button-${theme}`}>
        {label}
        <Icon color={iconColor}>{getIconForCTAButton()}</Icon>
      </Button>
    </Link>
  );
  if (icon) {
    const { position } = icon;
    return position === 'left' ? <CTAButtonLeftIcon /> : <CTAButtonRightIcon />;
  } else {
    return <CTAButtonOnly />;
  }
};
